import React from "react";

interface HighchartExportButtonProps {
  chartRef: React.RefObject<any>;
  title?: string;
}

const HighchartExportButton: React.FC<HighchartExportButtonProps> = ({
  chartRef,
  title = "Export Chart",
}) => {
  const handleClick = () => {
    const evt = new CustomEvent("closeAllDropdowns");
    window.dispatchEvent(evt);

    const chart: any = chartRef.current?.chart;
    const contextButton = chart?.exportSVGElements?.find((el: any) =>
      el.element?.getAttribute("class")?.includes("highcharts-contextbutton")
    );

    if (contextButton) {
      contextButton.element.dispatchEvent(
        new MouseEvent("click", { bubbles: true })
      );
    } else {
      console.warn("Export menu not found");
    }
  };

  return (
    <button
      onClick={handleClick}
      style={{
        cursor: "pointer",
        fontSize: "12px",
        padding: "0px 3px",
        position: "relative",
        right: "10px",
        color: "#0092d5",
        border: "1px solid #0092d5",
        background: "#f4f8fe",
        borderRadius: "17px",
        lineHeight: "0px",
      }}
      title={title}
    >
      <span className="material-symbols-outlined" style={{ fontSize: "17px" }}>
        downloading
      </span>
    </button>
  );
};

export default HighchartExportButton;
